// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CoolingGraphComponent } from '../cooling-graph/cooling-graph.component';
import { CoolingChartConfig } from '../../interfaces/chart-config.interface';
import { LocalDateFormat } from 'src/app/_interfaces/data/local-data-format-model';
import { GraphStatusType } from '../../interfaces/graph-state.interface';

@Component({
  selector: 'app-cooling-graph-display',
  standalone: true,
  imports: [CommonModule, TranslateModule, CoolingGraphComponent],
  templateUrl: './cooling-graph-display.component.html',
  styleUrl: './cooling-graph-display.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoolingGraphDisplayComponent {
  @Input() status: GraphStatusType = 'idle';
  @Input() config: CoolingChartConfig | null = null;
  @Input() dateFormat: LocalDateFormat | undefined;

  hasGraphData(config: CoolingChartConfig | null): boolean {
    return !!config?.series && config.series.length > 0;
  }
}
